import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import VueCookies from 'vue-cookies'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/form',
      name: 'form',
      component: () => import('./views/Form.vue')
    },
    {
      path: '/state',
      name: 'state',
      component: () => import('./views/State.vue')
    }
  ]
})

// 注册全局前置守卫
router.beforeEach((to, from, next) => {
  let openId = VueCookies.get('openId')
  if (openId) {
    next()
  } else {
    if (to.path === '/' || to.path === '/login') {
      next()
    } else {
      next('/')
    }
  }
})

export default router
